













import Vue from 'vue'

export default Vue.extend({
  props: {
    selectedName: {
      type: String,
      required: true
    }
  },
  methods: {
    openCategoryModal() {
      this.$emit('openCategoryModal')
    }
  }
})
